import React from "react";
import { SiInstagram, SiLinkedin, SiGithub } from "react-icons/si";
import "./CssFiles/home.css";
import { useSelector } from "react-redux";
import Information from "./Information";

const Social = () => {
  const { token, user, isLoading } = useSelector((state) => state.portfolio.auth);
  const { user_id, instagram, linkedIn, githubProfile } = useSelector((state) => state.portfolio.data);

  return (
    <div className="home__social">
      {!isLoading && user && token && user.uid === user_id && <Information />}

      {instagram && (
        <a
          href={instagram}
          className="home__social-icon"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <SiInstagram />
        </a>
      )}

      {linkedIn && (
        <a
          href={linkedIn}
          className="home__social-icon"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <SiLinkedin />
        </a>
      )}

      {githubProfile && (
        <a
          href={githubProfile}
          className="home__social-icon"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
        >
          <SiGithub />
        </a>
      )}
    </div>
  );
};

export default Social;
